import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/Button";
import { LookupTask } from "./LookupTask";
import { ReceiveTask } from "./ReceiveTask";
import { MoveTask } from "./MoveTask";
import { PickTask } from "./PickTask";
import { CountTask } from "./CountTask";

const TASKS = ["lookup", "receive", "move", "pick", "count"] as const;
type Task = (typeof TASKS)[number];

/**
 * Quét theo việc (18/09/2026, 0088) — màn kho cho điện thoại / máy quét, mỗi việc một màn: tra lô, nhận hàng, cất /
 * chuyển, xuất theo phiếu giao, kiểm kê. Việc đang chọn nằm trên đường dẫn (?task=…) để mở thẳng từ chỗ khác và để nút
 * quay lại của trình duyệt hoạt động đúng. Mỗi việc gọi đúng API của menu tương ứng — quyền là quyền của menu đó.
 */
export function ScanTasks() {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const task: Task = (TASKS as readonly string[]).includes(params.get("task") ?? "") ? (params.get("task") as Task) : "lookup";
  const select = (next: Task) => {
    const p = new URLSearchParams(params);
    p.set("task", next);
    setParams(p);
  };
  return (
    <div className="mx-auto max-w-2xl space-y-4">
      <p className="text-sm text-ink-soft">{t("scan.intro")}</p>
      <div className="flex flex-wrap gap-2" role="group" aria-label={t("scan.tabTasks")}>
        {TASKS.map((k) => (
          <Button key={k} className="h-11" variant={task === k ? "primary" : "secondary"} aria-pressed={task === k} onClick={() => select(k)}>
            {t(`scan.tasks.${k}`)}
          </Button>
        ))}
      </div>
      {task === "lookup" && <LookupTask />}
      {task === "receive" && <ReceiveTask />}
      {task === "move" && <MoveTask />}
      {task === "pick" && <PickTask />}
      {task === "count" && <CountTask />}
    </div>
  );
}
